import { RudderAnalytics } from "@rudderstack/analytics-js";
import { baseAssetsURL, rudderstackWriteKey } from "../config";

const rudderAnalytics = new RudderAnalytics();
rudderAnalytics.load(rudderstackWriteKey, "https://rs.blast.tv/", {
  pluginsSDKBaseURL: `${baseAssetsURL}/js/rsa/plugins/`,
});

export const rudderstack = rudderAnalytics;
